import { raise } from '../error';
import type { Optional } from '../object';
import { isNullOrUndefined } from '../object/object';
import { CASE_INSENSITIVE_REGEX, EMPTY_STRING } from './string-consts';

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function isNotString<Type>(value: Type): value is Exclude<Type, string> {
  return !isString(value);
}

export function validateIsString(value: unknown, name?: string): asserts value is string {
  if (!isString(value)) {
    raise(`${name ?? 'value'} is not a string`);
  }
}

export function isEmptyString(value: Optional<string>): value is undefined | null | '' {
  return isNullOrUndefined(value) || value === EMPTY_STRING;
}

export function isNotEmptyString(value: Optional<string>): value is string {
  return !isEmptyString(value);
}

export function validateNotEmptyString(value: Optional<string>, name?: string): asserts value is string {
  if (isEmptyString(value)) {
    raise(`${name ?? 'value'} is empty string`);
  }
}

export function caseInsensitiveIncludes(value: string, search: string): boolean {
  const regex = new RegExp(search, CASE_INSENSITIVE_REGEX);
 
  return value.match(regex) !== null;
}

export function sanitizeFilename(input: string) {
  const fileNameWithoutSpaces = input.replace(/\s+/g, '_');

  const validFileName = fileNameWithoutSpaces.replace(/[\/\\:*?"<>|]+/g, '');

  return validFileName === '' || validFileName.startsWith('.') 
    ? 'file' + validFileName
    : validFileName;
}

export function substringFromEnd(value: string, length: number): string {
  return value.substring(value.length - length);
}

export function shortenString(str: string, charCount: number) {
  const digits = -Math.abs(charCount);

  return str.slice(digits);
}

export function toLowerCase<Type extends string>(value: Type): Lowercase<Type> {
  return value.toLowerCase() as Lowercase<Type>;
}

export function toUpperCase<Type extends string>(value: Type): Uppercase<Type> {
  return value.toUpperCase() as Uppercase<Type>;
}

export function jsonStringToList(jsonString: string): string[] {
  return JSON.parse(jsonString);
}